import { z } from "zod";
export const chatMessage = z.object({
  id: z.string().uuid(),
  name: z.string(),
  message: z.string(),
  createdAt: z.string(),
  modelVerdict: z.enum(["allow", "review", "block"]),
});
export const chatQueue = z.object({ messages: z.array(chatMessage) });
export const chatDetail = z.object({
  message: chatMessage.extend({
    userId: z.string(),
    roomId: z.string(),
    reviewVersion: z.number(),
    removedAt: z.string().nullable(),
    model: z.string(),
    policyVersion: z.string(),
    context: z.object({
      omitted: z.number(),
      messages: z.array(
        z.object({ id: z.string(), name: z.string(), text: z.string(), sentAt: z.number() }),
      ),
    }),
  }),
  history: z.array(chatMessage),
  decisions: z.array(
    z.object({
      id: z.string(),
      verdict: z.string(),
      category: z.string(),
      reason: z.string(),
      createdAt: z.string(),
      moderatorId: z.string().nullable(),
      adminModeratorId: z.string().nullable().optional(),
    }),
  ),
  punishments: z.array(
    z.object({
      id: z.string(),
      action: z.string(),
      reason: z.string(),
      createdAt: z.string(),
      expiresAt: z.string().nullable(),
      moderatorId: z.string().nullable(),
      adminModeratorId: z.string().nullable().optional(),
    }),
  ),
  mutedUntil: z.string().nullable(),
});
export type ChatMessage = z.infer<typeof chatMessage>;
export type ChatDetail = z.infer<typeof chatDetail>;
